import { coreStakeholdersGetAsyncSlice } from './get';
import { CoreStakeholdersName } from './name';
import { createRemoveSyncSlice } from '@sonar-software/xuder';
import { DeleteStakeholderRequest } from '@api';

export const coreStakeholdersRemoveSyncSlice = createRemoveSyncSlice({
	name: CoreStakeholdersName,
	state: coreStakeholdersGetAsyncSlice.asyncState,
	transform: (action: DeleteStakeholderRequest, state) =>
		state?.filter((entry) => !action.stakeholderIds.includes(entry.stakeholderId)) ?? []
});
